module.exports = __webpack_public_path__ + "static/cb112dc89dce6238b7832435b4cdd1f78979d59b855b2267fbaa97b8cfaa5c0a-44291c08174b86f181ee34e0631793d1.jpeg";